import axios from 'axios';
import * as Constants from '../common/constants';
import * as HelperFunctions from '../common/functions/helperFunctions';
import AuthService from './authService';

class FileService {

  authService = new AuthService();

  constructor() {
    axios.defaults.baseURL = `${Constants.apiUrl}/`;
    axios.defaults.headers = {
      "Content-Type": "application/json; charset=utf-8",
      Pragma: 'no-cache'
    }
  }

  getMedicineLeaflets(id: number, lang: string) {
    return axios({
      url: `file/getLeaflets/${id}`,
      method: 'get',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Pragma: 'no-cache',
        "langId": HelperFunctions.getLangId(lang)
      }
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  getFile(id: number) {
    return axios({
      url: `file/getFile/${id}`,
      method: 'get'
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }

  openFile(id: number, fileName: string, fileSystemTypeId: number) {
    return axios({
      url: `file/openFile/${id}/${fileSystemTypeId}/${fileName}`,
      method: 'get',
      responseType: 'blob',
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Authorization: `Bearer ${this.authService.getToken()}`,
        Pragma: 'no-cache'
      }
    })
      .then(res => res.data)
      .catch(error =>
        Promise.reject(HelperFunctions.getErrorMessage(error))
      )
  }
}

export default FileService;
